import { useEffect, useMemo, useState } from 'react';

import { useCurrentClassVar } from 'approot/classes/classes.hooks';
import { useGetStudentAnswersOverview } from '../present/use-get-student-answers-overview';
import { INDIVIDUAL_VIEW, QUESTION_VIEW } from './classroom-answer-tabs';
import { hasAnswers } from '../components/shared/logic/has-answer';

const useInitialClassroomTab = ({
  isVisible,
  canRespond,
  componentId,
}: {
  isVisible?: boolean;
  canRespond?: boolean;
  componentId: string;
}) => {
  const [tab, setTab] = useState<string>(INDIVIDUAL_VIEW);

  const currentClass = useCurrentClassVar();

  const { data } = useGetStudentAnswersOverview({
    fetchPolicy: 'cache-first',
    skip: !canRespond || !currentClass?.id,
    classId: currentClass?.id || null,
    componentId,
  });

  const hasAnswerData = useMemo(
    () => hasAnswers(data?.getClassStudentsAnswers),
    [data]
  );

  useEffect(() => {
    setTab(hasAnswerData ? INDIVIDUAL_VIEW : QUESTION_VIEW);
  }, [isVisible, hasAnswerData]);

  return {
    tab,
    setTab,
  };
};

export default useInitialClassroomTab;
